import styled from "styled-components";
import { colors } from "../../../components/common/element/elements";

export const Styles = styled.div`
  .toilet-model {
    padding: 40px 0 85px;

    .about-image {
      position: relative;

      img.main-img {
        width: 90%;
        border-radius: 1rem;

        @media (max-width: 767px) {
          // display: none;
        }
      }

      img.pattern-img {
        position: absolute;
        top: 100%;
        left: 0;

        @media (max-width: 1199px) {
          max-width: 100%;
        }

        @media (max-width: 767px) {
          display: none;
        }
      }

      .video-player {
        width: 100%;
        height: 255px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        border-radius: 1rem;

        &::before {
          position: absolute;
          content: "";
          background-color: rgba(0, 0, 0, 0.2);
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          border-radius: 1rem;
        }

        button.play-button {
          position: absolute;
          z-index: 10;
          top: 50%;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);
          box-sizing: content-box;
          display: block;
          width: 32px;
          height: 44px;
          border-radius: 50%;

          i {
            position: relative;
            font-size: 40px;
            color: ${colors.bg1};
            z-index: 11;
            padding-top: 2px;
            margin-left: -2px;
          }

          &::before {
            content: "";
            position: absolute;
            z-index: 0;
            left: 50%;
            top: 50%;
            transform: translateX(-50%) translateY(-50%);
            display: block;
            width: 70px;
            height: 70px;
            background: #ffffff;
            border-radius: 50%;
            animation: pulse-border 1500ms ease-out infinite;
          }

          &:after {
            content: "";
            position: absolute;
            z-index: 1;
            left: 50%;
            top: 50%;
            transform: translateX(-50%) translateY(-50%);
            display: block;
            width: 70px;
            height: 70px;
            background: #ffffff;
            border-radius: 50%;
            transition: all 200ms;
          }

          &:hover {
            i {
              color: ${colors.water};
            }
          }

          @keyframes pulse-border {
            0% {
              transform: translateX(-50%) translateY(-50%) translateZ(0)
                scale(1);
              opacity: 1;
            }

            100% {
              transform: translateX(-50%) translateY(-50%) translateZ(0)
                scale(1.5);
              opacity: 0;
            }
          }
        }

        @media (max-width: 991px) {
          bottom: -70%;
        }

        @media (max-width: 767px) {
          position: unset;
          width: 100%;
          height: 250px;
          margin-bottom: 30px;
        }
      }
    }

    .about-content {
      h4.about-title {
        color: ${colors.black1};
        line-height: 35px;
        font-weight: 600;
        margin-bottom: 25px;

        @media (max-width: 575px) {
          margin-bottom: 15px;
          font-size: 20px;
        }
      }

      p.about-para {
        font-size: 15px;
        color: ${colors.text1};
        text-align: justify;
        line-height: 25px;
        margin-bottom: 40px;

        span {
          display: block;
          margin-top: 20px;
        }

        @media (max-width: 575px) {
          margin-bottom: 20px;
        }
      }

      .counter-box {
        h3 {
          margin-bottom: 10px;

          span {
            font-weight: 600;
          }

          i {
            font-size: 20px;
            vertical-align: middle;
          }
        }

        p {
          font-size: 14px;
          color: ${colors.text3};
          font-weight: 500;
        }

        @media (max-width: 575px) {
          display: none;
        }
      }

      .counter-box.box1 {
        h3 {
          color: ${colors.red};
        }
      }

      .counter-box.box2 {
        h3 {
          color: ${colors.purple};
        }
      }

      .counter-box.box3 {
        h3 {
          color: ${colors.blue};
        }
      }

      a.readmore-btn {
        font-size: 14px;
        color: #fff;
        background: ${colors.gr_bg};
        display: inline-block;
        width: 145px;
        height: 40px;
        text-align: center;
        padding: 11px;
        border-radius: 1rem;
        margin-top: 40px;

        &:hover {
          background: ${colors.gr_bg2};
        }

        @media (max-width: 575px) {
          margin-top: 0;
        }
      }
    }

    @media (max-width: 767px) {
      padding: 30px 0 40px;
    }
    .blockquote {
      font-size: 1.4em;
      width: 100%;
      margin: 50px auto;
      font-family: Open Sans;
      font-style: italic;
      color: #000;
      padding: 20px 30px;
      border-left: 8px solid ${colors.water};
      line-height: 1.6;
      position: relative;
      background: #ededed;
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 150px;
      }
    }

    .video-play-button {
      position: absolute;
      z-index: 10;
      top: 50%;
      left: 50%;
      -webkit-transform: translateX(-50%) translateY(-50%);
      transform: translateX(-50%) translateY(-50%);
      box-sizing: content-box;
      display: block;
      width: 32px;
      height: 44px;
      /* background: #fa183d; */
      border-radius: 50%;
      padding: 18px 20px 18px 28px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .video-play-button:before {
      content: "";
      position: absolute;
      z-index: 0;
      left: 50%;
      top: 50%;
      -webkit-transform: translateX(-50%) translateY(-50%);
      transform: translateX(-50%) translateY(-50%);
      display: block;
      width: 80px;
      height: 80px;
      background: ${colors.water};
      border-radius: 50%;
      -webkit-animation: pulse-border 1500ms ease-out infinite;
      animation: pulse-border 1500ms ease-out infinite;
    }
    .video-play-button:before:hover {
      background: green;
    }

    .video-play-button:after {
      content: "";
      position: absolute;
      z-index: 1;
      left: 50%;
      top: 50%;
      -webkit-transform: translateX(-50%) translateY(-50%);
      transform: translateX(-50%) translateY(-50%);
      display: block;
      width: 80px;
      height: 80px;
      background: ${colors.bg1};
      border-radius: 50%;
      -webkit-transition: all 200ms;
      transition: all 200ms;
    }

    .video-play-button:hover:after {
      background-color: red;
    }

    .video-play-button img {
      position: relative;
      z-index: 3;
      max-width: 100%;
      width: auto;
      height: auto;
    }

    .video-play-button span {
      display: block;
      position: relative;
      z-index: 3;
      width: 0;
      height: 0;
      border-left: 20px solid white;
      border-top: 15px solid transparent;
      border-bottom: 15px solid transparent;
    }

    @-webkit-keyframes pulse-border {
      0% {
        -webkit-transform: translateX(-50%) translateY(-50%) translateZ(0)
          scale(1);
        transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1);
        opacity: 1;
      }
      100% {
        -webkit-transform: translateX(-50%) translateY(-50%) translateZ(0)
          scale(1.5);
        transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1.5);
        opacity: 0;
      }
    }

    @keyframes pulse-border {
      0% {
        -webkit-transform: translateX(-50%) translateY(-50%) translateZ(0)
          scale(1);
        transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1);
        opacity: 1;
      }
      100% {
        -webkit-transform: translateX(-50%) translateY(-50%) translateZ(0)
          scale(1.5);
        transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1.5);
        opacity: 0;
      }
    }
    .video-overlay {
      position: fixed;
      z-index: -1;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.8);
      opacity: 0;
      -webkit-transition: all ease 500ms;
      transition: all ease 500ms;
    }

    .video-overlay.open {
      position: fixed;
      z-index: 1000;
      opacity: 1;
    }

    .video-overlay-close {
      position: absolute;
      z-index: 1000;
      top: 15px;
      right: 20px;
      font-size: 36px;
      line-height: 1;
      font-weight: 400;
      color: #fff;
      text-decoration: none;
      cursor: pointer;
      -webkit-transition: all 200ms;
      transition: all 200ms;
    }

    .video-overlay-close:hover {
      color: #fa183d;
    }

    .video-overlay iframe {
      position: absolute;
      top: 50%;
      left: 50%;
      -webkit-transform: translateX(-50%) translateY(-50%);
      transform: translateX(-50%) translateY(-50%);
      /* width: 90%; */
      /* height: auto; */
      box-shadow: 0 0 15px rgba(0, 0, 0, 0.75);
    }

    .model-table {
      color: black !important;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .cell-1,
      .cell-3 {
        flex: 1;
        border: 1px solid black;
        h3 {
          font-size: 16px;
          font-weight: bold;
          color: black;
          border-bottom: 1px solid black;
          padding: 5px;
        }
      }
      .cell-2 {
        flex: 1;
        border-top: 1px solid black;
        border-bottom: 1px solid black;
        h3 {
          font-size: 16px;
          font-weight: bold;
          color: black;
          border-bottom: 1px solid black;
          padding: 5px;
        }
      }
    }
  }
`;
